<mat-dialog-content>
    <div style="display: flex; flex-flow: row wrap;">
      <mat-icon
        style="width: auto;
        height: 68px;
        font-size: 4rem;
        margin: 0rem 1.5rem;"
        aria-hidden="false"
        aria-label="Notification">
        notifications_active
      </mat-icon>
      <div>
        <h2 style="margin-bottom: 8px;" mat-dialog-title>{{'User-Settings.Messaging.Notificacion' | translate}}</h2>
        <p>{{'User-Settings.Messaging.Content' | translate}}</p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="false">{{'User-Settings.Messaging.Cancel' | translate}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{'User-Settings.Messaging.ActiveNotification' | translate}}</button>
  </mat-dialog-actions>
  